import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '../app-routes/AppRoutes';
import { AuthRoutes } from '../auth-routes/AuthRoutes';
import { useAuthContext } from '../../shared/contexts/AuthContext';

export const Routes: React.FC = () => {
    const { isAuthenticated } = useAuthContext();

    return (
        <BrowserRouter>
            {isAuthenticated ? <AppRoutes /> : <AuthRoutes />}
        </BrowserRouter>
    );
};